import styles from './AdViseFrame.module.css';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AdViseStep0 from './StepPages/AdViseStep0';
import AdViseStep1 from './StepPages/AdViseStep1';
import AdViseStep2 from './StepPages/AdViseStep2';
import AdViseStep3 from './StepPages/AdViseStep3';
import AdViseStep4 from './StepPages/AdViseStep4';
import AdViseStep5 from './StepPages/AdViseStep5';
import AdViseStep6 from './StepPages/AdViseStep6';
import AdViseStep7 from './StepPages/AdViseStep7';
import AdViseStep8 from './StepPages/AdViseStep8';
import AdViseStep9 from './StepPages/AdViseStep9';
import AdViseFileViewer from './StepPages/AdViseFileViewer';
import AdViseStep10 from './StepPages/AdViseStep10';
import CommentManager from './CommentManager/CommentManager';
import FollowingManager from './FollowingManager/FollowingManager';

const AdviseFrame = () => {
  const [marginTop, setMarginTop] = useState(0);
  const [adViseStep, setAdViseStep] = useState(0);
  const [initialFollowingRegion, setInitialFollowingRegion] = useState(null);
  const location = useLocation();
  const [stepProps, setStepProps] = useState([{},
    null,
    'advise',
    {hotple:null, hotples:[], region:null, category:'전체', currentPage:0, filterText:'',hotThreshold:999999},
    {place:null, blogReviews:[], blogImageUrls:[], blogTexts:[], visitorReviews:[], placeId: null, reviewAnalysis: null, placeAnalysis: null, stage:0},
    'image',
    {blogImages:[], officialImages:[], gifImages:{}, blogCursor:0, selectedImages:[], placeId: null, thumbnailIndex: null, priorityIndex:[], selectedOfficialImages:[], authorIds:[]},
    {imageAnalysis: [], conti: null, placeId: null, selectedImages:[], originalImages:[]},
    {result:[], video_preview:[], ratio:'4/5', file: null, fileName: null, oriFileName: null, pages:[], pagePalettes:[], addLastPromotionPage:false},
    {caption:null, result:null},
    {adviseId: null, comment:'[HOTPLE 앱 출시 이벤트 진행]\n프로필의 링크 참고 부탁드려요❤️\n@hotple_kr', needComment:true, needInstagramUpload: true, needPageUpload: true, needOfficialUpload: true, resourceStatus:{}}
  ]); //0번은 null, 이후부턴 step 1~6별 props

  function updateMarginTop() {
    const searchParams = new URLSearchParams(window.location.search);
    const marginTop = searchParams.get('marginTop');

    if (marginTop) {
      setMarginTop(parseInt(marginTop, 10));
    }
  }

  useEffect(() => {
    updateMarginTop();
    const newUrl = window.location.origin+'/advise';
    window.history.replaceState({}, '', newUrl);
  }, []);

  useEffect(() => {
    const { pathname, search } = location;
    // 1) /advise/following 로 들어왔을 때
    if (pathname.endsWith('/advise/following')) {
      const params = new URLSearchParams(search);
      const r = params.get('region'); // URLSearchParams는 자동 디코딩됨
      setInitialFollowingRegion(r || '전지역');
      setAdViseStep(31);
      return;
    }
    // 2) /advise?screen=following&region=서울 같은 식도 허용
    if (pathname.endsWith('/advise')) {
      const params = new URLSearchParams(search);
      if ((params.get('screen') || params.get('view')) === 'following') {
        const r = params.get('region');
        setInitialFollowingRegion(r || '전지역');
        setAdViseStep(31);
      }
    }
  }, [location]);

  return (
    <div className={styles.adviseFrameContainer} style={{paddingTop: marginTop, height:`calc(100dvh - ${marginTop}px)`}}>
        <>
          {adViseStep == 0 && <AdViseStep0 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps}/>}
          {adViseStep == 1 && <AdViseStep1 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 2 && <AdViseStep2 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 3 && <AdViseStep3 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 4 && <AdViseStep4 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 5 && <AdViseStep5 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 6 && <AdViseStep6 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 7 && <AdViseStep7 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 8 && <AdViseStep8 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 9 && <AdViseStep9 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 10 && <AdViseStep10 setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 20 && <AdViseFileViewer setAdViseStep={setAdViseStep} stepProps={stepProps} setStepProps={setStepProps} marginTop={marginTop}/>}
          {adViseStep == 30 && <CommentManager setAdViseStep={setAdViseStep}/>}
          {adViseStep == 31 && <FollowingManager setAdViseStep={setAdViseStep} initialRegion={initialFollowingRegion} />
          }
        </>
    </div>
  );
}

export default AdviseFrame;